import { currencyFormatter } from 'tools/helper'
import { formatCurrency } from 'tools/formatters'
const Status = [
  {
    status: 'Approved',
    code: 'var(--badge-approved-bg)',
    chartColor: '#2F7D63',
    color: 'var(--badge-approved-ink)',
    abbreviation: 'Approved',
  },
  {
    status: 'Pending',
    code: 'var(--badge-watch-bg)',
    chartColor: '#EA6F39',
    color: 'var(--badge-watch-ink)',
    abbreviation: 'Pending',
  },
  {
    status: 'New',
    code: 'var(--badge-review-bg)',
    chartColor: '#B2A1FF',
    color: 'var(--badge-review-ink)',
    abbreviation: 'New',
  },
  {
    status: 'Declined',
    code: 'var(--badge-declined-bg)',
    chartColor: '#A93B22',
    color: 'var(--badge-declined-ink)',
    abbreviation: 'Declined',
  },
  {
    status: 'Under Review',
    code: 'var(--badge-review-bg)',
    chartColor: '#6F5BD8',
    color: 'var(--badge-review-ink)',
    abbreviation: 'Under Review',
  },
  {
    status: 'Cancelled',
    code: 'var(--badge-closed-bg)',
    chartColor: '#56706E',
    color: 'var(--badge-closed-ink)',
    abbreviation: 'Cancelled',
  },
  {
    status: 'Cautionary Approval',
    code: 'var(--badge-approved-bg)',
    chartColor: '#6FAE96',
    color: 'var(--badge-approved-ink)',
    abbreviation: 'Cautionary App',
  },
  {
    status: 'Draft',
    code: 'var(--badge-closed-bg)',
    chartColor: '#A6B4B2',
    color: 'var(--badge-closed-ink)',
    abbreviation: 'Draft',
  },
  {
    status: 'Needs More Information',
    code: 'var(--badge-watch-bg)',
    chartColor: '#C9531F',
    color: 'var(--badge-watch-ink)',
    abbreviation: 'Needs More Info',
  },
]

const Risk = [
  {
    value: 'Low Risk',
    code: 'var(--badge-approved-bg)',
    textCode: 'var(--badge-approved-ink)',
    abbreviation: 'Low',
  },
  {
    value: 'High Risk',
    code: 'var(--badge-declined-bg)',
    textCode: 'var(--badge-declined-ink)',
    abbreviation: 'High',
  },
  {
    value: 'Medium Risk',
    code: 'var(--badge-watch-bg)',
    textCode: 'var(--badge-watch-ink)',
    abbreviation: 'Medium',
  },
  {
    value: 'Needs Review',
    code: 'var(--badge-review-bg)',
    textCode: 'var(--badge-review-ink)',
    abbreviation: 'No Value',
  },
]

const detection = [
  {
    status: 'Early Detection',
    code: '#CDDBFF',
  },
  {
    status: 'Mature',
    code: '#3E3679',
  },
  {
    status: 'Tombstoned',
    code: '#8F9DE9',
  },
  {
    status: 'Unknown',
    code: '#775DD0',
  }
]

const DonutChart = {
  plotOptions: {
    pie: {
      startAngle: 0,
      expandOnClick: true,
      offsetX: 0,
      offsetY: 0,
      customScale: 1,
      dataLabels: {
        enabled: false,
        offset: 0,
        minAngleToShowLabel: 10,
      },
      donut: {
        size: "60%",
        background: "transparent",
        height: '9rem',
        labels: {
          show: true,
          name: {
            show: true,
            fontSize: "20px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 600,
            color: undefined,
            offsetY: -10,
            offsetX: -10,
            formatter: function (val) {
              return `${val}`;
            },
          },
          value: {
            show: true,
            fontSize: "20px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 700,
            color: undefined,
            offsetY: -10,
            formatter: function (val) {
              return `$ ${val}`;
            },
          },
          total: {
            show: true,
            showAlways: true,
            label: " ",
            fontSize: "30px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 600,
            color: "#5f7472",
            formatter: function (w) {
              return w.globals.seriesTotals.reduce((a, b) => {
                return a + b;
              }, 0);
            },
          },
        },
      },
    },
  },
  series: [],
  labels: Status.map(s => s.status),
  colors: Status.map(s => s.chartColor)
};

const ApplicationValueChart = {
  plotOptions: {
    pie: {
      startAngle: 0,
      expandOnClick: true,
      offsetX: 0,
      offsetY: 0,
      customScale: 1,
      dataLabels: {
        enabled: false,
        offset: 0,
        minAngleToShowLabel: 10,
      },
      donut: {
        size: "60%",
        background: "transparent",
        height: '9rem',
        labels: {
          show: true,
          name: {
            show: true,
            fontSize: "20px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 600,
            color: undefined,
            offsetY: -10,
            offsetX: -10,
            formatter: function (val) {
              return `${val}`;
            },
          },
          value: {
            show: true,
            fontSize: "20px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 700,
            color: undefined,
            offsetY: -10,
            formatter: function (val) {
              return `$ ${val}`;
            },
          },
          total: {
            show: true,
            showAlways: true,
            label: " ",
            fontSize: "30px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 600,
            color: "#5f7472",
            formatter: function (w) {
              return '$' + currencyFormatter(w.globals.seriesTotals.reduce((a, b) => {
                return a + b;
              }, 0));
            },
          },
        },
      },
    },
  },
  series: [],
  labels: Status.map(s => s.status),
  colors: Status.map(s => s.chartColor)
};

const recurringPaymentChart = {
  series: [],
  options: {
    chart: {
      type: 'pie',
      width: 500,
      height: 500,
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 500,
          height: 500
        },
        legend: {
          position: 'bottom'
        }
      }
    }],
    labels: detection.map(s => s.status),
    colors: detection.map(s => s.code),
    plotOptions: {
      pie: {
        startAngle: 0,
        endAngle: 360,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
          offset: 10,
          minAngleToShowLabel: 10,
        },
        donut: {
          size: '50%',
          background: 'transparent',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return `${val}%`;
      },
      style: {
        fontSize: '20px',
        colors: ['#6f5bd8']
      },
      background: {
        enabled: true,
        foreColor: '#5f7472',
        opacity: 1,
        borderRadius: '10px',
        borderWidth: 0,
        padding: 8,
        dropShadow: {
          enabled: false,
        }
      },
      dropShadow: {
        enabled: false,
      }
    },
  }
}

const monthlyStatementsChart = (months) => {
  return (
    {
      options: {
        chart: {
          type: 'line',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 3,
          curve: 'smooth'
        },
        xaxis: {
          categories: months || ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        },
        yaxis: {
          show: true,
          labels: {
            formatter: function (val) {
              return `${val / 1000}K`
            }
          }
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#6f5bd8', '#2f7d63'],
        markers: {
          size: 1,
          colors: ['#6f5bd8', '#2f7d63'],
          strokeWidth: 5,
          strokeOpacity: 1,
          shape: "circle",
          radius: 2,
          strokeColors: ['#6f5bd8', '#2f7d63'],
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          offsetY: -50,
        },
        title: {
          text: 'Income & Expense Data',
          align: 'left',
          margin: 0,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
            fontWeight: 'lighter',
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: function (val) {
              return formatCurrency(val)
            }
          },
        }
      }
    }
  )
}

const creditHistoryAreaChart = {
  chart: {
    toolbar: {
      show: false
    }
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: 'straight'
  },
  legend: {
    position: "top",
    horizontalAlign: "right"
  }
}

const MonthlyBalanceChart = {
  chart: {
    toolbar: {
      show: false
    }
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
    },
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent']
  },
  markers: {
    radius: 12,
  },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      colorStops: [
        [
          {
            offset: 0,
            color: "#6f5bd8",
            opacity: 1
          },
          {
            offset: 100,
            color: "#2f7d63",
            opacity: 1
          },
        ],
        [
          {
            offset: 0,
            color: "#ea6f39",
            opacity: 1
          },
          {
            offset: 100,
            color: "#ABB1EE",
            opacity: 1
          },
        ]
      ]
    }
  },
  colors: ['#6f5bd8', '#2f7d63'],
  tooltip: {
    y: {
      formatter: function (val) {
        return `${val} USD`
      }
    }
  },
  legend: {
    position: "top",
    horizontalAlign: "right"
  }
}

const DBTLineChart = {
  chart: {
    type: 'line',
    toolbar: {
      show: false
    }
  },
  colors: ['#6f5bd8'],
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 1,
    curve: 'straight'
  },
  markers: {
    size: 5,
    colors: '#3F51B5',
    hover: {
      sizeOffset: 2
    }
  },
  legend: {
    showForSingleSeries: true,
    position: "top",
    horizontalAlign: "right"
  }
}

const interpolateColor = (color1, color2, factor) => {
  const hex = (color) => parseInt(color.slice(1), 16);
  const interpolate = (c1, c2, factor) => Math.round(c1 + factor * (c2 - c1));

  const r1 = hex(color1) >> 16;
  const g1 = (hex(color1) >> 8) & 0x00FF;
  const b1 = hex(color1) & 0x0000FF;

  const r2 = hex(color2) >> 16;
  const g2 = (hex(color2) >> 8) & 0x00FF;
  const b2 = hex(color2) & 0x0000FF;

  const interpolatedColor = `#${((interpolate(r1, r2, factor) << 16) | (interpolate(g1, g2, factor) << 8) | interpolate(b1, b2, factor)).toString(16).padStart(6, '0')}`;

  return interpolatedColor;
};

const getEndColorForVerificationGauge = (percentage) => {
  if (isNaN(percentage)) return '#3DCA5F';

  const initialColor = '#3DCA5F';
  const finalColor = '#CA5F23';

  if (percentage === 0) return initialColor;
  if (percentage === 100) return finalColor;

  const factor = percentage / 100;
  return interpolateColor(initialColor, finalColor, factor);
};

const verificationRadialChart = (value, customvalue) => {
  return {
    chart: {
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -100,
        endAngle: 100,
        hollow: {
          margin: 0,
          size: "80%",
          background: "#fff",
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 4,
            opacity: 0.1
          }
        },
        track: {
          background: "#E4E4E4",
          strokeWidth: "30%",
          margin: 0,
          dropShadow: {
            enabled: true,
            top: -1,
            left: 0,
            blur: 4,
            opacity: 0.3
          }
        },

        dataLabels: {
          show: true,
          value: {
            offsetY: -12,
            formatter: function (val) {
              if (isNaN(customvalue)) {
                return '-'
              } else {
                return parseInt(customvalue);
              }
            },
            color: "#3F51B5",
            fontSize: "31px",
            show: true,
            fontWeight: 800
          },
          name: {
            offsetY: 17,
            show: true,
            color: "rgba(125, 125, 125, 0.89)",
            fontSize: "12px",
            fontWeight: 600
          },
        }
      }
    },
    fill: {
      colors: ["#3DCA5F"],
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: [getEndColorForVerificationGauge(customvalue)],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [value || 'No Data']
  }
};

const creditRatingRadialChart = (value, customvalue) => {
  return {
    chart: {
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -100,
        endAngle: 100,
        hollow: {
          margin: 0,
          size: "80%",
          background: "#fff",
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 4,
            opacity: 0.1
          }
        },
        track: {
          background: "#E4E4E4",
          strokeWidth: "30%",
          margin: 0,
          dropShadow: {
            enabled: true,
            top: -1,
            left: 0,
            blur: 4,
            opacity: 0.3
          }
        },

        dataLabels: {
          show: true,
          value: {
            offsetY: -12,
            formatter: function (val) {
              return parseInt(customvalue || val);
            },
            color: "#3F51B5",
            fontSize: "31px",
            show: true,
            fontWeight: 800
          },
          name: {
            offsetY: 17,
            show: true,
            color: "rgba(125, 125, 125, 0.89)",
            fontSize: "12px",
            fontWeight: 600
          },
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ["#3F51B5"],
        inverseColors: true,
        opacityFrom: 0.8,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [value]
  }
};

// `name` is the key the API response is matched against, so it must not change.
// `label` is what the tile shows (03-6: no two tiles read the same).
const ApplicationOverview = [
  {
    name: 'Open Applications',
    label: 'Open value',
    icon: 'openApplication',
    dsIcon: 'grid',
    value: 0
  },
  {
    name: 'Open applications',
    label: 'Open applications',
    icon: 'noOfApplication',
    dsIcon: 'list',
    value: 0
  },
  {
    name: 'Completed Applications',
    label: 'Completed value',
    icon: 'completedApplication',
    dsIcon: 'check-circle',
    value: 0
  },
  {
    name: 'Completed applications',
    label: 'Completed applications',
    icon: 'noOfCompletedApplication',
    dsIcon: 'check',
    value: 0
  },
  {
    name: 'Average Duration',
    label: 'Avg duration',
    icon: 'average',
    dsIcon: 'clock',
    value: 0
  },
]

const currency = ['Open Applications', 'Completed Applications']

const OnboardedToFC = [
  {
    status: "Onboarded",
    code: 'var(--badge-approved-bg)',
    color: 'var(--badge-approved-ink)',
    border: 'var(--badge-approved-border)',
    abbreviation: 'Onboarded',
    tooltip: 'Onboarded to FactorCloud',
  },
  {
    status: "Pending Approval",
    code: 'var(--badge-watch-bg)',
    color: 'var(--badge-watch-ink)',
    border: 'var(--badge-watch-border)',
    abbreviation: 'Pending Approval',
    tooltip: 'Pending Approval to onboard to FactorCloud',
  },
  {
    status: "Onboarding disabled",
    code: 'var(--badge-closed-bg)',
    color: 'var(--badge-closed-ink)',
    border: 'var(--badge-closed-border)',
    abbreviation: 'Onboarding disabled',
    tooltip: 'Onboarding to FactorCloud was not enabled for this application',
  },
  {
    status: "Onboarding Error",
    code: 'var(--badge-declined-bg)',
    color: 'var(--badge-declined-ink)',
    border: 'var(--badge-declined-border)',
    abbreviation: 'Onboarding Error',
    tooltip: 'Click here to see the details',
  },
]

export {
  DonutChart,
  ApplicationOverview,
  ApplicationValueChart,
  Status,
  Risk,
  recurringPaymentChart,
  monthlyStatementsChart,
  detection,
  currency,
  creditHistoryAreaChart,
  MonthlyBalanceChart,
  DBTLineChart,
  creditRatingRadialChart,
  verificationRadialChart,
  OnboardedToFC
}